var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 7.951 7.951 0 00-8-8zm0 14.857A6.857 6.857 0 1114.857 8 6.877 6.877 0 018 14.857z",
    fill: "#e0e0e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.415 11.13L8 8.715 5.585 11.13l-.715-.715L7.285 8 4.87 5.585l.715-.715L8 7.285l2.415-2.415.715.715L8.715 8l2.415 2.415z",
    fill: "#e0e0e0"
  })));
}

export default SvgIconCloseCircle;